/**
 * Reports where a visitor went to the telemetry service.
 *
 * Sends the path they opened and, where it is a service, its name — nothing
 * about who clicked. Failures are swallowed: telemetry is an observer, and a
 * visitor must never see an error because a counter could not be recorded.
 */

// Read when called rather than at import. Module-load reads bake the value
// in at first require, which makes the behaviour impossible to exercise
// without resetting the module registry.
const telemetryUrl = () => (process.env.REACT_APP_TELEMETRY_URL || "").replace(/\/$/, "");

/** The public domain shown in the feed, rather than whatever host serves it. */
const siteDomain = () => process.env.REACT_APP_SITE_DOMAIN || "www.newageservices.in";

/** "/Services/Services#ITConsulting" -> "www.newageservices.in/Services/Services#ITConsulting" */
export function displayUrl(path) {
  const clean = String(path || "/");
  return `${siteDomain()}${clean.startsWith("/") ? clean : `/${clean}`}`;
}

/**
 * @param {string} path the destination, e.g. "/Services/Services#ITConsulting"
 * @param {string} [service] the service name when the click was a service
 * @returns {Promise<boolean>} whether it was recorded
 */
export function trackPage(path, service = "") {
  const base = telemetryUrl();
  if (!base) return Promise.resolve(false);

  return fetch(`${base}/api/visitor`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    // A service name is required by the endpoint, so fall back to the path —
    // which is what the feed shows anyway.
    body: JSON.stringify({ service: service || path, page: path }),
    // The click usually navigates away immediately after this fires.
    keepalive: true,
  })
    .then((res) => res.ok)
    .catch(() => false);
}

/** Convenience for a service card. */
export const trackService = (service, path) => trackPage(path, service);

export default trackPage;
